import React from 'react';

const PaginationNextArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M4.16666 10.5H15.8333M15.8333 10.5L9.99999 4.66663M15.8333 10.5L9.99999 16.3333"
        stroke="#667085"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PaginationNextArrowIcon;